// extracted by mini-css-extract-plugin
export default {"CardGrid":"index-module--CardGrid--pYu-v","CardGrid__grid":"index-module--CardGrid__grid--8+xZI"};